module.exports = {
    tag: 'murderous',
    quality: 0,
    perception: -2,
    mana: -2,
    damageMod: 0.2
};